import React from 'react';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import {
  categorySalesPageRequest,
  changeDateCategorySales,
  changeOutletCategorySales,
  exportCategorySales,
} from 'actions/reports/sales';
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import withFeatureFlags from 'hocs/withFeatureFlags';
import LoadingSpinner from 'components/LoadingSpinner';
import TableScrollHorizontalVertical from 'components/TableScrollHorizontalVertical';
import { currencyFormatter, percentWithNegative } from 'utils/formatter';
import TableWithoutChild from 'components/TableReportSales/TableWithoutChild';
import * as clevertapReportsCategorySales from 'clevertap/reports/categorySales';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import styles from './CategorySales.css';
import { csvName } from '../../../../utils/formatterCsvName';
import ActionBar from '../ActionBar';
import BodyFrame from '../BodyFrame';

class CategorySales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headerPaneCategory: Cookies.get('headerPaneCategory'),
    };
  }

  componentDidMount() {
    this.props.dispatch(categorySalesPageRequest());
  }

  render() {
    const {
      categorySales,
      showLoadingSpinnerReport,
    } = this.props.data.reports.categorySales;
    const { useReportingGraphqlApi } = this.props;
    const { categorySalesReport } = categorySales;
    const dataFormatter = useReportingGraphqlApi
      ? this._formatDataForListGraphql
      : this._formatDataForList;
    const dataFormatterResponsive = useReportingGraphqlApi
      ? this._formatDataForListResponsiveGraphql
      : this._formatDataForListResponsive;
    const [parentBody, childBody, childFoot] = dataFormatter(categorySales);
    const [childFootResponsive, childBodyResponsive] = dataFormatterResponsive(
      categorySales
    );
    let fTueStatusCategory;
    if (Cookies.get('headerPaneCategory') === undefined) {
      fTueStatusCategory = true;
    } else {
      fTueStatusCategory = false;
    }
    /* component TableScrollHorizontalVertical ->  childHeaders and childBody must same name, exmp: if childBody = items_sold childHeaders must Items Sold same character. this for sort dimanis on table */
    return (
      <div id="reports-sales-category-sales" className={styles.wrapper}>
        <ActionBar
          onExport={this._onClickExport}
          onChangeOutlet={this._onChangeOutlet}
          onChangeDate={this._onChangeDate}
        />
        <BodyFrame location={this.props.location}>
          <div
            className={`${styles.tableWrapper} category-sales-table visible-md visible-lg`}
          >
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {this.state.headerPaneCategory === undefined && (
              <div className={`${styles.header_panel} panel panel-default`}>
                <div className="panel-body">
                  <button
                    type="button"
                    className="close"
                    onClick={this._hideHeaderPane}
                  >
                    <span aria-hidden="true">×</span>
                    <span className="sr-only">Close</span>
                  </button>
                  <h5 className={`${styles.thickTitle}`}>Gross Profit</h5>
                  <p>
                    To report gross profit accurately per category, please make
                    sure all items have a COGS.
                  </p>
                </div>
              </div>
            )}
            {categorySalesReport.length > 0 && (
              <TableScrollHorizontalVertical
                parentHeader={'Category'}
                parentBody={parentBody}
                parentFoot={'Total'}
                fTueStatusCategory={fTueStatusCategory}
                parentClassName={['p-header', 'p-body', 'p-foot']}
                childHeaders={[
                  'Items Sold',
                  'Items Refunded',
                  'Gross Sales',
                  'Discount',
                  'Refund',
                  'Net Sales',
                  'COGS',
                  'Gross Profit',
                  'Gross Margin',
                ]}
                childBody={childBody}
                childFoot={childFoot}
                childHeaderClassName={[
                  'header-item-sold',
                  'header-item-refunded',
                  'header-gross-sales',
                  'header-discount',
                  'header-refund',
                  'header-net-sales',
                  'header-cogs',
                  'header-gross-profit',
                  'header-gross-margin',
                ]}
                childBodyClassName={[
                  'body-item-sold',
                  'body-item-refunded',
                  'body-gross-sales',
                  'body-discount',
                  'body-refund',
                  'body-net-sales',
                  'body-cogs',
                  'body-gross-profit',
                  `${styles.body_gross_margin}`,
                ]}
                childFootClassName={[
                  'foot-item-sold',
                  'foot-item-refunded',
                  'foot-gross-sales',
                  'foot-discount',
                  'foot-refund',
                  'foot-net-sales',
                  'foot-cogs',
                  'foot-gross-profit',
                  `${styles.body_gross_margin}`,
                ]}
              />
            )}
            {!categorySalesReport.length && !showLoadingSpinnerReport && (
              <div className="no-data-display-container">
                <NoDataDisplay title="No Data to Display" />
              </div>
            )}
          </div>
          <div
            className={`${styles.tableWrapperResponsive} visible-xs visible-sm`}
          >
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {this.state.headerPaneCategory === undefined && (
              <div className={`${styles.header_panel} panel panel-default`}>
                <div className="panel-body">
                  <button
                    type="button"
                    className="close"
                    onClick={this._hideHeaderPane}
                  >
                    <span aria-hidden="true">×</span>
                    <span className="sr-only">Close</span>
                  </button>
                  <h5 className={`${styles.thickTitle}`}>Gross Profit</h5>
                  <p>
                    To report gross profit accurately per category, please make
                    sure all items have a COGS.
                  </p>
                </div>
              </div>
            )}
            {categorySalesReport.length > 0 && (
              <TableWithoutChild
                headerBody={['Name', 'Items Sold', 'Gross Sales']}
                childBody={childBodyResponsive}
                footBody={childFootResponsive}
                tableClass="category-sales-table-responsive"
                headerBodyClassName={[
                  'header-name',
                  'header-items-sold',
                  'header-gross-sales',
                ]}
                childBodyClassName={[
                  'body-name',
                  'body-items-sold',
                  'body-gross-sales',
                ]}
                footBodyClassName={[
                  'foot-name',
                  'foot-items-sold',
                  'foot-gross-sales',
                ]}
              />
            )}
            {!categorySalesReport.length && !showLoadingSpinnerReport && (
              <div className="no-data-display-container">
                <NoDataDisplay title="No Data to Display" />
              </div>
            )}
          </div>
        </BodyFrame>
      </div>
    );
  }

  _generateChildBody = categorySale => {
    // this is used by both legacy and revamp so the gross margin will still be counted here
    const calculatedDiscount = categorySale.discount;
    const getGrossMargin = categorySale.grossProfit / categorySale.netSales;
    return {
      items_sold: categorySale.itemSold,
      items_refunded:
        categorySale.itemRefunded !== 0 ? categorySale.itemRefunded : '',
      gross_sales:
        Number.isFinite(categorySale.grossSales) &&
        currencyFormatter(categorySale.grossSales),
      discount:
        Number.isFinite(-calculatedDiscount) &&
        currencyFormatter(-calculatedDiscount),
      refund:
        Number.isFinite(-categorySale.refund) &&
        currencyFormatter(-categorySale.refund),
      net_sales:
        Number.isFinite(-categorySale.netSales) &&
        currencyFormatter(-categorySale.netSales),
      cogs:
        Number.isFinite(-categorySale.cogs) &&
        currencyFormatter(-categorySale.cogs),
      gross_profit:
        Number.isFinite(categorySale.grossProfit) &&
        currencyFormatter(categorySale.grossProfit),
      gross_margin:
        categorySale.netSales !== 0 && !isNaN(Math.round(getGrossMargin))
          ? percentWithNegative(Math.round(getGrossMargin * 100))
          : '',
    };
  };

  _formatDataForList = categorySales => {
    const { categorySalesReport } = categorySales;
    const parentBody = [];
    const childBody = [];
    const childFoot = {
      total_items_sold: null,
      total_items_refunded: null,
      total_gross_sales: null,
      total_discount: null,
      total_refund: null,
      total_net_sales: null,
      total_cogs: null,
      total_gross_profit: null,
      total_gross_margin: null,
    };

    categorySalesReport.map(categorySale => {
      const calculatedDiscount = categorySale.discount;
      parentBody.push(categorySale.categoryName);
      childBody.push(this._generateChildBody(categorySale));
      childFoot.total_items_sold =
        childFoot.total_items_sold + categorySale.itemSold;
      childFoot.total_items_refunded =
        childFoot.total_items_refunded + categorySale.itemRefunded;
      childFoot.total_gross_sales =
        childFoot.total_gross_sales + categorySale.grossSales;
      childFoot.total_discount =
        childFoot.total_discount + Math.round(calculatedDiscount);
      childFoot.total_refund =
        childFoot.total_refund + Math.round(categorySale.refund);
      childFoot.total_net_sales =
        childFoot.total_net_sales + Math.round(categorySale.netSales);
      childFoot.total_cogs =
        childFoot.total_cogs + Math.round(categorySale.cogs);
      childFoot.total_gross_profit =
        childFoot.total_gross_profit + Math.round(categorySale.grossProfit);
      childFoot.total_gross_margin =
        childFoot.total_net_sales !== 0 &&
        !isNaN(
          Math.round(childFoot.total_gross_profit / childFoot.total_net_sales)
        )
          ? percentWithNegative(
              Math.round(
                (childFoot.total_gross_profit / childFoot.total_net_sales) * 100
              )
            )
          : '';
    });

    childFoot.total_gross_sales =
      Number.isFinite(childFoot.total_gross_sales) &&
      currencyFormatter(childFoot.total_gross_sales);

    childFoot.total_items_refunded =
      childFoot.total_items_refunded === 0
        ? ''
        : childFoot.total_items_refunded;

    childFoot.total_discount =
      childFoot.total_discount === 0 ? null : childFoot.total_discount;
    childFoot.total_discount =
      Number.isFinite(childFoot.total_discount) &&
      currencyFormatter(childFoot.total_discount);

    childFoot.total_refund =
      childFoot.total_refund === 0
        ? null
        : currencyFormatter(-childFoot.total_refund);
    childFoot.total_net_sales =
      Number.isFinite(childFoot.total_net_sales) &&
      currencyFormatter(childFoot.total_net_sales);
    childFoot.total_cogs =
      Number.isFinite(childFoot.total_cogs) &&
      currencyFormatter(childFoot.total_cogs);
    childFoot.total_gross_profit =
      Number.isFinite(childFoot.total_gross_profit) &&
      currencyFormatter(childFoot.total_gross_profit);
    return [parentBody, childBody, childFoot];
  };

  _formatDataForListGraphql = categorySales => {
    const { categorySalesReport, categorySalesSummaryReport } = categorySales;
    const parentBody = [];
    const childBody = [];
    const childFoot = {
      total_items_sold: categorySalesSummaryReport.itemSold,
      total_items_refunded: categorySalesSummaryReport.itemRefunded,
      total_gross_sales: currencyFormatter(
        categorySalesSummaryReport.grossSales
      ),
      total_discount: currencyFormatter(categorySalesSummaryReport.discount),
      total_refund: currencyFormatter(-categorySalesSummaryReport.refund),
      total_net_sales: currencyFormatter(categorySalesSummaryReport.netSales),
      total_cogs: currencyFormatter(categorySalesSummaryReport.cogs),
      total_gross_profit: currencyFormatter(
        categorySalesSummaryReport.grossProfit
      ),
      total_gross_margin: categorySalesSummaryReport.grossMargin,
    };

    categorySalesReport.forEach(categorySales => {
      parentBody.push(categorySales.categoryName);
      childBody.push(this._generateChildBody(categorySales));
    });

    return [parentBody, childBody, childFoot];
  };

  _formatDataForListResponsiveGraphql = categorySales => {
    const { categorySalesReport, categorySalesSummaryReport } = categorySales;
    const childBody = categorySalesReport.map(categorySale => ({
      name: categorySale.categoryName,
      items_sold: categorySale.itemSold,
      gross_sales: currencyFormatter(categorySale.grossSales),
    }));
    const footBody = {
      name: 'Total',
      total_items_sold: categorySalesSummaryReport.itemSold,
      total_gross_sales: currencyFormatter(
        categorySalesSummaryReport.grossSales
      ),
    };
    return [footBody, childBody];
  };

  _formatDataForListResponsive = categorySales => {
    const { categorySalesReport } = categorySales;
    const childBody = [];
    const footBody = {
      name: 'Total',
      total_items_sold: null,
      total_gross_sales: null,
    };
    if (categorySalesReport) {
      categorySalesReport.map(function(categorySale) {
        childBody.push({
          name: categorySale.categoryName,
          items_sold: categorySale.itemSold,
          gross_sales:
            Number.isFinite(categorySale.grossSales) &&
            currencyFormatter(categorySale.grossSales),
        });
        footBody.total_items_sold =
          footBody.total_items_sold + categorySale.itemSold;
        footBody.total_gross_sales =
          footBody.total_gross_sales + categorySale.grossSales;
      });
      footBody.total_gross_sales =
        Number.isFinite(footBody.total_gross_sales) &&
        currencyFormatter(footBody.total_gross_sales);
    }
    return [footBody, childBody];
  };

  _onChangeOutlet = outletIds => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeOutletCategorySales({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
      })
    );
  };

  _hideHeaderPane = () => {
    Cookies.set('headerPaneCategory', false, {
      path: '/',
      domain: '.mokapos.com',
    });
    this.setState({ headerPaneCategory: false });
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { outlet } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeDateCategorySales(formattedStart, formattedEnd, outlet)
    );
  };

  _onClickExport = () => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { outlet } = this.props.search;
    const { outlets } = this.props;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const filename = csvName(
      moment(formattedStart),
      moment(formattedEnd),
      'Report Category Sales',
      outlet,
      outlets,
      allDay
    );
    const query = {
      startDate: formattedStart,
      endDate: getFormattedEndDate(formattedEnd),
      timeZone: '',
    };
    clevertapReportsCategorySales.reportsCategorySalesExport({
      outletIds: outlet,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
    this.props.dispatch(exportCategorySales(query, filename, outlet));
  };
}

const selector = formValueSelector('search');

function select(state) {
  return {
    outlets: state.actionBar.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    data: {
      reports: {
        categorySales: state.reports.categorySales,
      },
    },
  };
}

const mapFlagsToProps = flags => ({
  useReportingGraphqlApi: flags.useReportingGraphqlApi,
});

export default withFeatureFlags(mapFlagsToProps)(
  connect(select)(CategorySales)
);
